module.exports = __webpack_public_path__ + "static/apiTeam@2x-5a72bbd0df3f17c4851dca773b2b1b8f.png";


//////////////////
// WEBPACK FOOTER
// ./src/media/images/pages/developers/apiTeam@2x.png
// module id = 2551
// module chunks = 168707334958949